module.exports = __webpack_public_path__ + "img/victory.f7188a32.png";